import type { TypedWrappedFieldProps } from "redux-form";
import { change } from "redux-form";

import { useButtonSelect } from "@braintrust/braintrust-ui-components";
import {
  EarthIcon,
  LockSmallIcon,
} from "@braintrust/braintrust-ui-components/Icons";
import { useAppDispatch } from "@js/hooks";

import { CREATE_JOB_FORM_ID } from "../../constants";

import type { VisibilityOption } from "./visibility-setting";
import { VisibilitySetting } from "./visibility-setting";

const visibilityOptions: VisibilityOption[] = [
  {
    icon: <EarthIcon sx={{ fontSize: "16px" }} />,
    iconColor: { selected: "var(--positive-2)", notSelected: "var(--black)" },
    label: "Public",
    description: "Everyone on Braintrust can view this job",
    value: false,
  },
  {
    icon: <LockSmallIcon sx={{ fontSize: "16px" }} />,
    iconColor: { selected: "var(--negative-2)", notSelected: "var(--black)" },
    label: "Private",
    description: "Only invited Talent can view this job",
    value: true,
  },
];

type VisibilitySettingsSelectFieldProps = TypedWrappedFieldProps<
  boolean | null
>;

export const VisibilitySettingsSelectField = ({
  input,
  meta,
}: VisibilitySettingsSelectFieldProps) => {
  const { value, onChange } = input;
  const error = meta.touched && meta.error;
  const { isSelected, handleChange } = useButtonSelect({
    value,
    onChange,
  });
  const dispatch = useAppDispatch();

  const handleClick = (option: VisibilityOption) => {
    dispatch(change(CREATE_JOB_FORM_ID, "auto_invite_talent", !option.value));

    handleChange(option);
  };

  return (
    <>
      {visibilityOptions.map((option) => {
        const _isSelected = isSelected(option);

        return (
          <VisibilitySetting
            key={option.value.toString()}
            onClick={() => handleClick(option)}
            {...option}
            selected={_isSelected}
          />
        );
      })}
      {error && <div className="general-form-error">{error}</div>}
    </>
  );
};
